import { render, staticRenderFns } from "./BrokerForm.vue?vue&type=template&id=8cfa2516&scoped=true&"
import script from "./BrokerForm.vue?vue&type=script&lang=js&"
export * from "./BrokerForm.vue?vue&type=script&lang=js&"
import style0 from "./BrokerForm.vue?vue&type=style&index=0&id=8cfa2516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfa2516",
  null
  
)

export default component.exports